<template>
  <div class="user">
    <div style="">
    <div >
     
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="订单状态">
          <el-select v-model="formInline.status" placeholder="请选择状态" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="已接受" value="1"></el-option>
            <el-option label="已拒绝" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content" >
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="order_no" label="货运单号"></el-table-column>
           <el-table-column prop="supplier.name" label="商家"></el-table-column>
            <el-table-column prop="supplier.address" label="起点"></el-table-column>
            <el-table-column prop="products[0].productInfo.product_name" label="货物描述"></el-table-column>
            <el-table-column label="状态" width="120">
              <template slot-scope="scope">
                <el-tag :type="scope.row.hy_accept === 1 ? 'success' : 'danger'">
                  {{ scope.row.hy_accept === 1 ? '已接受' : (scope.row.hy_accept === 2 ? '已拒绝' : '未分配') }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="指定货运商" width="200">
  <template slot-scope="scope">
    <el-select 
      v-model="scope.row.new_hy_id" 
      placeholder="请选择货运商"
      @change="handleSupplierChange(scope.row)"
      size="small"
      style="width: 100%"
      :disabled="scope.row.hy_accept === 1"
    >
      <el-option
        v-for="supplier in supplierList"
        :key="supplier.user_id"
        :label="supplier.nickName+'('+supplier.mobile+')'"
        :value="supplier.user_id"
      />
    </el-select>
  </template>
</el-table-column>
            <!-- <el-table-column label="指定货运商" width="200">
              <template slot-scope="scope">
                <el-select 
      v-model="scope.row.new_hy_id" 
      placeholder="请选择货运商"
      @change="handleSupplierChange(scope.row)"
      size="small"
      style="width: 100%"
      :disabled="scope.row.hy_accept === 1"
    >
      <el-option
        v-for="supplier in supplierList"
        :key="supplier.user_id"
        :label="supplier.nickName"
        :value="supplier.user_id"
      />
    </el-select>
  </template>
</el-table-column> -->
            <el-table-column prop="remarks" label="备注"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column label="操作" width="90">
                <template slot-scope="scope">
                  <el-button 
      @click="handleConfirm(scope.row)" 
      type="text" 
      size="small"
      :disabled="scope.row.hy_accept === 1"
    >
      确定
    </el-button>
  </template>
</el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>


      </div>
 
    <div style="clear: both;"></div>
    </div>
    
  
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :waybill_id="waybill_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="分配其它货运公司" :visible.sync="dialogVisible" @close='dialogFormVisible' 
  :close-on-click-modal="false" 
             :close-on-press-escape="false" :append-to-body="true">
      <div>
          <Hy_s  @handleCurrentChange="handleCurrentChangeS"></Hy_s>

          <div style="clear: both;"></div>
      </div>
     

  </el-dialog>
  
  </div>
</template>

<script>
  import WaybillApi from '@/api/waybill.js';
  import OrderApi from '@/api/order.js';
  import HyApi from '@/api/hy.js';
  import SupplyApi from '@/api/supply.js';
  import Supply_s from '@/components/select/supply';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import Hy_s from '@/components/select/hy';
  export default {
    components: {
      Add,
      Edit,
      Supply_s,
      Hy_s
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          status: "" // 添加状态筛选字段
        },

        open_add:false,
        open_edit:false,
        waybill_id:"",
        dialogVisible:false,


        supply_search:"",
        supplierList: [],    
        currentRow :null,
        new_hy_id:0,
        user_id:0,
      };
    },
    mounted() {
       this.loadSuppliers();   // 初始化加载货运商
       },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      dialogFormVisible(){
        this.dialogVisible = false;
      },
        // 加载货运商列表
  async loadSuppliers() {
    let self = this
    try {
      this.loading = true;
      // const res = await this.$api.get('/api/suppliers');
      HyApi.userlist()
      .then(data => {
        self.loading = false
        self.supplierList = data.data.list.data
        console.log('self.supplierList',self.supplierList)
      //  self.new_hy_id = self.supplierList.hy_id
        console.log("data",data);
        
      })
      .catch(error => {
        console.log(error);
        
        self.loading = false
      });;
    } catch (err) {
      console.error('加载货运商失败:', err);
      this.$message.error('货运商加载失败');
    } finally {
      this.loading = false;
    }
  },

  // 选择货运商时的操作
  handleSupplierChange(row) {
    console.log('当前选择:', {
      supplierId: row
    });
  },

  // 点击确认按钮
  async handleConfirm(row) {
    console.log(row);
    
    if (!row.new_hy_id) {
      this.$message.warning('请先选择货运商');
      return;
    }

    try {
      await OrderApi.updateShippingInfo({
        hy_accept: 1, // 设置为已接受
        new_hy_id: row.new_hy_id,
        shipping_id: row.shipping_id
      })
      this.$message.success('分配成功');
      this.$emit('refresh'); // 通知父组件刷新数据
      this.getData()
    } catch (err) {
      this.$message.error('分配失败: ' + err.message);
    }
  },
      noClick(e){//货运单标题设置
        this.user_id = e.user_id;
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },
      handleCurrentChangeS(val){
        this.formInline.supply_id = val.id
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
  let self = this;
  self.loading = true;
  OrderApi.shippinggetId()
    .then(res => {
      console.log("formInline.status", this.formInline.status);
      
      let filteredData = res.data.data;
      if (this.formInline.status) {
        filteredData = filteredData.filter(item => item.hy_accept == this.formInline.status);
      }
      
      self.tableData = filteredData; // Only assign the filtered data
      console.log("filtered tableData", self.tableData);
    })
    .catch(error => {
      console.log(error);
      self.loading = false;
    })
    .finally(() => {
      self.loading = false;
    });
},

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.waybill_id = row.waybill_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            WaybillApi.del(
              {
                waybill_id: row.waybill_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
    }
  };
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/plus/hy/index/order.vue